var render = function () {
var this$1 = this;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-nav-item',_vm._b({attrs:{"href":_vm.$attrs.href,"to":_vm.$attrs.to,"disabled":_vm.disabled},on:{"click":function () { return this$1.$emit('click'); }}},'b-nav-item',_vm.$attrs,false),[_vm._t("default"),_c('span',{staticClass:"link-text"},[_vm._v(_vm._s(_vm.text))]),(_vm.disabled)?_c('lock-icon',{staticClass:"lock-icon",attrs:{"fillColor":"#3687ff","size":20}}):_vm._e()],2)}
var staticRenderFns = []

export { render, staticRenderFns }